import * as React from 'react';
import * as styles from './PageShared.module.scss';
import { PageVerticalQuery } from '../gatsby-queries';
import PageWrapper, { IPageProps } from './PageWrapper';
import { FormattedMessage } from 'react-intl';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
import { Sine, gsap } from 'gsap/dist/gsap.min';
import ModulesWrapper from '../components/ModulesWrapper';
import { FixedTopSectionNav } from '../ui/FixedTopSectionNav';
import { zeroPad } from '../utils/StringUtils';
import { Helmet } from 'react-helmet';
import ViewableMonitor from '../components/ui/ViewableMonitor';
import { GatsbyImageWrapper } from '../components/ui/GatsbyImageWrapper';
import { graphql } from 'gatsby';
import JuicerFeed from '../lib/juicer-feed/juicer-feed';
import { ModuleDynamicList } from '../components/ModuleDynamicList';
import { PressListItem } from '../components/ListItems/PressListItem';
import { getPagePath } from '../utils/URLHelper';
import DownloadForm from '../ui/UIDownloadForm';
import { UIImageCircle } from '../ui/IDKT/UIImageCircle';
import { UIProcess } from '../ui/IDKT/UIProcess';
import { UIProcessResearchers } from '../ui/IDKT/UIProcessResearchers';
import { UIProcessEntrepreneurs } from '../ui/IDKT/UIProcessEntrepreneurs';
//import UIArtContestForm from '../ui/PPF/UIArtContestForm';
//import UIECSSForm from '../ui/UIECSSForm';

interface Props extends IPageProps {
	data: PageVerticalQuery;
}

class PageVertical extends React.Component<Props> {

	componentDidMount() {
		gsap.registerPlugin(ScrollToPlugin);
		if (this.props.data?.contentfulPageVertical.slug === "idkt/technologies") {
			const script = document.createElement('script')
			script.async = true
			script.defer = true
			script.src = 'https://qf.flintbox.com/embed.js'
			document.querySelector('div#flintbox-embed').appendChild(script)
		}
		if (this.props.data?.contentfulPageVertical.slug === 'eiu') {
			var wrapper = document.getElementById("section-2");
			var form = document.querySelector(".bx--form").parentElement;
			var download = document.getElementById("download");
			var download_access_cookie = typeof document !== 'undefined' && document.cookie
			var cookie = ("; "+ download_access_cookie).split("; download_access_granted=").pop().split(";").shift();
			if(cookie === '1') {
				form.parentElement.style.display = 'none'
				download.style.display = 'block'
				wrapper.appendChild(download);
			} else {
				wrapper.appendChild(form);
				wrapper.appendChild(download);
			}
		}

		if (this.props.data?.contentfulPageVertical.slug === 'idkt/for-industry' || this.props.data?.contentfulPageVertical.slug === 'idkt/for-researchers' || this.props.data?.contentfulPageVertical.slug === 'idkt/for-entrepreneurs') {
			var wrapper = document.getElementById("section-2");
			var chart = document.getElementById("chart");

			wrapper.appendChild(chart);
		}

		/**
		if (this.props.data.contentfulPageVertical.slug === 'idkt/about') {
			var wrapper = document.getElementById("section-4");
			var dynamicModule = document.getElementById("dynamic-module");

			wrapper && wrapper.appendChild(dynamicModule);
		}

		if (this.props.data.contentfulPageVertical.slug === 'ppf-art-contest') {
			var wrapper = document.getElementById("section-4");
			var dynamicModule = document.getElementById("ppf-art-contest-form");

			wrapper.appendChild(dynamicModule);
		}
		*/

		/**
		if (this.props.data.contentfulPageVertical.slug === 'education-city-speaker-series') {

			document.querySelectorAll('a[href^="#ecss_form"]').forEach(anchor => {
				anchor.addEventListener('click', function (e) {
					e.preventDefault();
					document.querySelector(this.getAttribute('href')).scrollIntoView({ behavior: 'smooth', block: 'center' });
				});
			})

			var wrapper = document.getElementById("ecss_form");
			var form = document.querySelector(".bx--form").parentElement;
			var download = document.getElementById("download");
			var download_access_cookie = typeof document !== 'undefined' && document.cookie
			var cookie = ("; "+ download_access_cookie).split("; ecss_access_granted_1=").pop().split(";").shift();
			if(cookie === '1') {
				form.parentElement.style.display = 'none'
				download.style.display = 'block'
				wrapper.prepend(download);
			} else {
				wrapper.prepend(form);
				wrapper.prepend(download);
			}
		}
		**/

		if(window.location.hash) {
			this.scrollToHandler(this)
		}
	}

	private scrollToHandler = event => {
		let hash;
		let offsetY = 0
		if(window.location.hash.substring(1)) {
			hash = '#' + window.location.hash.substring(1);
		} else {
			hash = event.target.getAttribute('href')
			event.preventDefault()
		}

		if (hash === '#formdone') {
			return;
		}
		if (event) {
			gsap.to(window, { scrollTo: { y: hash, offsetY: offsetY, autoKill: false }, ease: Sine.easeInOut });
		}
	};

	private getTopNavSection(sections: any[]) {
		return (
			<div data-swiftype-index="false" className={styles.topSectionNav}>
				<h6 className={`text-style-quoted-by ${styles.sectionTitle}`}>
					<FormattedMessage id="Sections" />
				</h6>
				<ul>
					{sections.map((module, index) => {
						return (
							<li key={module.id}>
								<a onClick={this.scrollToHandler} className={`text-style-link-1 ${styles.sectionLink}`} href={`#section-${index + 1}`}>
									{zeroPad(index + 1)}. {module.title}
								</a>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

	render() {
		if (!this.props.data) {
			return <h1 style={{'marginTop': '100px'}}>ERROR</h1>;
		}
		const pageData = this.props.data.contentfulPageVertical;
		//@ts-ignore:
		const pressReleaseData = this.props.data.allPR;
		//@ts-ignore:
		const idktPressReleaseData = this.props.data.idktPR;
		let modules = [];
		if (pageData.modulesWrapper) {
			pageData.modulesWrapper.forEach(moduleWrapper => modules.push(...moduleWrapper.modules));
		}
		let sections = [];
		modules.map(module => {
			if (module.__typename === 'ContentfulModuleSectionIntroduction') {
				sections.push(module);
			}
		});

		return (
			//@ts-ignore:
			<PageWrapper location={this.props.location} pageData={pageData} type={'vertical'} title={pageData.title} metaTitle={pageData.metaTitle} pathContext={this.props.pathContext}>
				<div className="container pagePaddingTop">

					<Helmet>
						{
						//@ts-ignore:
						pageData.metaDescription && ( <meta name="description" content={pageData.metaDescription.metaDescription} /> )}
						<meta className="swiftype" name="preview_image" data-type="enum" content={pageData.heroImage && pageData.heroImage.file.url} />
						<meta className="swiftype" name="type" data-type="enum" content="page" />
					</Helmet>
					{sections.length > 0 && <FixedTopSectionNav sections={sections} />}
					<ViewableMonitor>
						<div className={styles.topSection}>
							{
								// @ts-ignore
								<div className={`${pageData.fullWidthLayout ? 'col-md-12' : 'col-md-6 col-xl-4'} ${styles.topSectionText}`}>
									{
										// @ts-ignore
										<h1 className={`text-style-h1 ${pageData.fullWidthLayout && 'max-width'}`}>{pageData.headline && pageData.headline.headline}</h1>
									}
									{
										// @ts-ignore
										<p className={`text-style-body ${styles.subtitle} ${pageData.fullWidthLayout ? 'text-style-introduction' : ''}`} dangerouslySetInnerHTML={{ __html: pageData.subtitle && pageData.subtitle.subtitle }} />
									}
								</div>
							}
							{sections.length > 0 && this.getTopNavSection(sections)}
						</div>
					</ViewableMonitor>
					<ViewableMonitor delay={3}>
						{
						// @ts-ignore
						<GatsbyImageWrapper alt={pageData.heroImage && pageData.heroImage.title} outerWrapperClassName={`w-100 ${styles.heroImage}`} fluid={pageData.heroImage && pageData.heroImage.sizes} />
						}
					</ViewableMonitor>
					<ModulesWrapper
						languageCode={this.props.pathContext.languageCode}
						programsListData={this.props.data.allContentfulPageProgram}
						upcomingEventsData={this.props.pathContext.upcomingEvents}
						hasHeroImage={true}
						data={pageData.modulesWrapper}
						slug={pageData.slug}
					>
						{pageData.slug == 'media-center' && pressReleaseData && (
							<ModuleDynamicList position={21} count={pressReleaseData.edges.length} title={<FormattedMessage id="Press Releases" />}>
								<ul>
									{pressReleaseData.edges.map((edge, index) => {
										return <PressListItem title={edge.node.title} date={edge.node.date} url={getPagePath(edge.node.slug, 'press')} key={index} />;
									})}
								</ul>
							</ModuleDynamicList>
						)}
						{false && pageData.slug == 'idkt/about' && idktPressReleaseData && (
							<ModuleDynamicList position={20} count={idktPressReleaseData.edges.length} title={<FormattedMessage id="Press Releases" />}>
								<ul>
									{idktPressReleaseData.edges.map((edge, index) => {
										// @ts-ignore
										return <PressListItem title={edge.node.title} date={edge.node.date} url={getPagePath(edge.node.slug, 'press')} key={index} />;
									})}
								</ul>
							</ModuleDynamicList>
						)}
					</ModulesWrapper>
				</div>
				{pageData.slug == 'convocation' && (
					<div className="module-margin">
						<JuicerFeed feedId="agatabraja" />
					</div>
				)}
				{pageData.slug === 'eiu' && (
					<DownloadForm currLang={this.props.pathContext.languageCode} />
				)}
				{pageData.slug == 'idkt' && (
					<div className="module-margin">
						<UIImageCircle currLang={this.props.pathContext.languageCode} />
					</div>
				)}
				{pageData.slug == 'idkt/for-industry' && (
					<div className="module-margin">
						<UIProcess currLang={this.props.pathContext.languageCode} />
					</div>
				)}
				{pageData.slug == 'idkt/for-researchers' && (
					<div className="module-margin">
						<UIProcessResearchers  currLang={this.props.pathContext.languageCode} />
					</div>
				)}
				{pageData.slug == 'idkt/for-entrepreneurs' && (
					<div className="module-margin">
						<UIProcessEntrepreneurs currLang={this.props.pathContext.languageCode} />
					</div>
				)}
				{
				/**
				pageData.slug === 'ppf-art-contest' && (
					<UIArtContestForm currLang={this.props.pathContext.languageCode} />
				)}
				{
				pageData.slug === 'education-city-speaker-series' && (
					<UIECSSForm currLang={this.props.pathContext.languageCode} />
				)
				**/
				}
			</PageWrapper>
		);
	}
}

export default PageVertical;

export const pageQuery = graphql`
	query PageVerticalQuery($id: String, $languageCode: String) {
		contentfulPageVertical(contentful_id: { eq: $id }, node_locale: { eq: $languageCode }) {
			id
			slug
			title
			headline {
				headline
			}
			subtitle {
				subtitle
			}
			metaTitle
			metaDescription {
				metaDescription
			}
			heroImage {
				title
				file {
					url
				}
				sizes(maxWidth: 1680, maxHeight: 700, resizingBehavior: FILL, quality: 85) {
					...GatsbyContentfulSizes_withWebp_noBase64
				}
			}
			modulesWrapper {
				...ContentfulModuleWrapperFragment
			}
			fullWidthLayout
		}
		allContentfulPageProgram(filter: { node_locale: { eq: $languageCode }, title: { ne: "WORKAROUND. DO NOT DELETE." } }, sort: { order: ASC, fields: [title] }) {
			edges {
				node {
					slug
					title
					filterEntity {
						title
						contentful_id
					}
					filterProgramType {
						title
						contentful_id
					}
				}
			}
		}

		allPR: allContentfulPagePressRelease(filter: { node_locale: { eq: $languageCode }, title: { ne: "WORKAROUND. DO NOT DELETE." } }, limit: 10, sort: { order: DESC, fields: [date] }) {
			edges {
				node {
					title
					slug
					date
				}
			}
		}

		idktPR: allContentfulPagePressRelease(filter: { node_locale: { eq: $languageCode }, filterTags: {elemMatch: {title: {eq: "IDKT"}}}}, limit: 10, sort: { order: DESC, fields: [date] }) {
			edges {
			  node {
				title
				slug
				date
			  }
			}
		}
	}
`;
